const fb = require('../../firebaseConfig.js')

export default {
  state: {
    words: [],
    loader: false,
    lastVisible: null,
    isGettingNextWords: false,
    allWords: false
  },
  mutations: {
    setWords(state, val) {
      state.words = val
    },
    setAddWord(state, word) {
      // console.log(Object.assign({ wordUid: word.id }, word.data()))
      state.words.unshift(Object.assign({ wordUid: word.id }, word.data()));
    },
    // setDeleteWord(state, word) {
    //   state.words = state.words.filter(function (wordToDelete) {
    //     return wordToDelete.id != word.id
    //   });
    // },
    setModifyWord(state, word) {
      // console.log(state.words.findIndex(x => x.wordUid == word.id))
      // console.log(state.words.find(x => x.id === word.id))
      // let i = state.words.map(w=>(w.id)).indexOf(word.id)
      // if(i!= -1){
      state.words = state.words.map(w => (w.wordUid == word.id ? Object.assign({ wordUid: word.id }, word.data()) : w))
      // state.words[state.words.map(w=>(w.uid)).indexOf(word.data())] =  Object.assign({ wordUid: word.id }, word.data())
      // }
      //state.words.find(x => x.uid === word.id) = Object.assign({ wordUid: word.id }, word.data())
    },
    setAllWords(state, val) {
      state.allWords = val
    },
    SET_LOADER(state, val) {
      state.loader = val
    },
    SET_LAST_VISIBLE(state, val) {
      state.lastVisible = val
    },
    SET_IS_GETTING_NEXT_WORDS(state, val) {
      state.isGettingNextWords = val
    },
  },
  actions: {
    getAllWords({ commit, getters, state}){
      if (state.allWords) return
      commit("SET_LOADER", true)
      commit("setAllWords", true)
      commit("setWords", [])
      fb.wordsCollection
        .orderBy("createdOn", "desc")
        .where("language", "==", getters.userProfile.language)
        .onSnapshot(
          snapshot => {
            snapshot.docChanges().forEach(function (change) {
              if (change.type === "added") {
                commit('setAddWord', change.doc)
              }
              if (change.type === "modified") {
                commit('setModifyWord', change.doc)
              }
            });
            commit('SET_LOADER', false)
          },
          error => {
            console.log(error);
          }
        );
    },
    // getNextWords({ commit, getters, state }) {
    //   commit('SET_IS_GETTING_NEXT_WORDS', true)
    //   let listWords = [];

    //   var next = fb.wordsCollection
    //     .orderBy("createdOn", "desc")
    //     .where("language", "==", getters.userProfile.language)
    //     .startAfter(state.lastVisible)
    //     .limit(25);

    //   next.get().then(function (documentSnapshots) {
    //     // Get the last visible document
    //     var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];
    //     // console.log("last", lastVisible);
    //     commit('SET_LAST_VISIBLE', lastVisible)

    //     documentSnapshots.forEach((word) => {
    //       // console.log(`${word.id} => ${word.data()}`);
    //       listWords.push(Object.assign({ wordUid: word.id }, word.data()));
    //     });
    //     // console.log(listWords)
    //     commit('SET_WORDS', state.words.concat(listWords))
    //     commit('SET_IS_GETTING_NEXT_WORDS', false)

    //   })
    // },
    getWords({ commit, getters, state }) {
      commit('SET_LOADER', true)
      if (localStorage.listWords) {
        commit('setWords', JSON.parse(localStorage.getItem("listWords")))
      }
      // let listWords = [];

      // var first = fb.wordsCollection
      //   .orderBy("createdOn", "desc")
      //   .where("language", "==", getters.userProfile.language)
      //   .limit(25)

      // first.get().then(function (documentSnapshots) {
      //   // Get the last visible document
      //   var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];
      //   // console.log("last", lastVisible);
      //   commit('SET_LAST_VISIBLE', lastVisible)

      //   documentSnapshots.forEach((word) => {
      //     // console.log(`${word.id} => ${word.data()}`);
      //     listWords.push(Object.assign({ wordUid: word.id }, word.data()));
      //   });
      //   // console.log(listWords)
      //   commit('SET_LOADER', false)
      //   commit('SET_WORDS', listWords)
      //   // localStorage.setItem("listWords", JSON.stringify(listWords));
      // })


      fb.wordsCollection
        .orderBy("createdOn", "asc")
        .where("language", "==", getters.userProfile.language)
        .onSnapshot(
          snapshot => {
            // console.log(snapshot)

            snapshot.docChanges().forEach(function (change) {
              // console.log(change.type)
              if (change.type === "added") {
                commit('setAddWord', change.doc)
              }
              if (change.type === "modified") {
                commit('setModifyWord', change.doc)
              }
              // if (change.type === "removed") {
              //   console.log(change.doc)
              //   commit('setDeleteWord', change.doc)
              // }
            });
            // let listWords = [];
            // snapshot.forEach(word => {
            //   console.log(word)
            //   listWords.push(Object.assign({ wordUid: word.id }, word.data()));
            // });
            //console.log(listWords)
            //listWords.sort(function (a, b) { return Object.keys(b.learners).length - Object.keys(a.learners).length });

            // listWords = listWords.filter(function (data) {
            //   return data.reported.length < 3
            // });
            // let newWords = listWords.filter(function (data) {
            //   return data.createdOn.seconds * 1000 > new Date().getTime() - 1000 * 60 * 60 * 24;
            // });
            // let oldWords = listWords.filter(function (data) {
            //   return data.createdOn.seconds * 1000 < new Date().getTime() - 1000 * 60 * 60 * 24
            // });
            // listWords = newWords.concat(oldWords)
            // listWords.sort(function (a, b) { return Object.keys(b.learners).length - Object.keys(a.learners).length });

            // listWords.sort(function(a,b) {return (a.createdOn < b.createdOn) ? 1 : ((b.createdOn < a.createdOn) ? -1 : 0);} )

            // commit('SET_WORDS', listWords)
            commit('SET_LOADER', false)
            localStorage.setItem("listWords", JSON.stringify(state.words));
          },
          error => {
            console.log(error);
          }
        );
    }
  },
  getters: {

  }
};
